if (!customElements.get('atc-total-price')) {
  customElements.define(
    'atc-total-price',
    class ATCTotalPrice extends HTMLElement {
      connectedCallback() {
        this.priceEl = this.querySelector('.add-to-cart__price');
        if (!this.priceEl) return;

        this.priceCompareEl = this.querySelector('.add-to-cart__price-compare');
        this.unitPrice = parseInt(this.dataset.unitPrice, 10) || 0;
        this.comparePrice = parseInt(this.dataset.comparePrice, 10) || 0;
        this.currency = this.dataset.currency || 'EUR';
        this.sectionId = this.dataset.section;

        try {
          this.variants = JSON.parse(this.dataset.variants || '[]');
        } catch (e) {
          this.variants = [];
        }

        this.quantityInput =
          document.querySelector(`#Quantity-Form-${this.sectionId} .quantity-input`) ||
          this.closest('form')?.querySelector('.quantity-input') ||
          document.querySelector('.product-form-quantity .quantity-input');

        this.onQtyChange = () => this.render();
        if (this.quantityInput) {
          this.quantityInput.addEventListener('input', this.onQtyChange);
          this.quantityInput.addEventListener('change', this.onQtyChange);
        }

        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
          this.unsubscribeVariant = subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
            const sid = event?.data?.sectionId;
            if (sid && String(sid) !== String(this.sectionId)) return;
            const vid = event?.data?.variantId;
            if (!vid) return;
            const match = this.variants.find((v) => String(v.id) === String(vid));
            if (match) {
              this.unitPrice = parseInt(match.price, 10) || 0;
              this.render();
            }
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribeVariant) this.unsubscribeVariant();
        if (this.quantityInput && this.onQtyChange) {
          this.quantityInput.removeEventListener('input', this.onQtyChange);
          this.quantityInput.removeEventListener('change', this.onQtyChange);
        }
      }

      render() {
        if (!this.priceEl) return;
        const qty = Math.max(1, parseInt(this.quantityInput?.value, 10) || 1);
        this.priceEl.textContent = this.formatMoney(this.unitPrice * qty);
        if (this.priceCompareEl && this.comparePrice > 0) {
          this.priceCompareEl.textContent = this.formatMoney(this.comparePrice * qty);
        }
      }

      formatMoney(cents) {
        if (typeof window.Shopify?.formatMoney === 'function' && window.Shopify?.money_format) {
          return window.Shopify.formatMoney(cents, window.Shopify.money_format);
        }
        try {
          const locale = document.documentElement.lang || 'fr-FR';
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: this.currency,
          }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2) + ' ' + this.currency;
        }
      }
    }
  );
}
